export const OUTPUT_REPORT_OLD_ADMIN_URL =
    (import.meta.env.REACT_APP_OLD_ADMIN_URL as string | undefined) ?? '';
